// #region imports

// --- Angular
import { Component, OnInit, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-toggle-icon',
  templateUrl: './toggle-icon.component.html',
  styleUrls: ['./toggle-icon.component.scss']
})
export class ToggleIconComponent implements OnInit {

  @Input() primaryIcon: string;
  @Input() secondaryIcon: string;

  @Input() iconPack: 'material';

  private _currentIcon: string;

  @Input()
  set active(value: boolean) {
    this._currentIcon = value ? this.primaryIcon : this.secondaryIcon;
  }

  get currentIcon() {
    return this._currentIcon || this.primaryIcon;
  }
  constructor() { }

  ngOnInit() {
  }

}
